__turbopack_context__.v({
  "iconWrapper": "ZW394G_iconWrapper",
  "socialItems": "ZW394G_socialItems",
});
